import { useMemo } from "react";
import { CustomTable } from "../../componentes/table/CustomTable";

function TabelaVolumeEntregue({ data, onRowClick, loading }) {

    const columns = useMemo(() => [
        {
            key: "filialNome",
            label: "Filial",
            sortable: true,
        },
        {
            key: "funcionarioCodigo",
            label: "Cód. Func.",
            sortable: true,
            center: true,
        },
        {
            key: "funcionarioNome",
            label: "Funcionário",
            sortable: true,
        },
        {
            key: "funcionarioCargo",
            label: "Cargo",
            sortable: true,
        },
        {
            key: "quantidadesEscalasDeRota",
            label: "Escalas",
            sortable: true,
            center: true,
        },
        {
            key: "cubosEntregue1Auxiliar",
            label: "Cub. c/ 1 Aux",
            sortable: true,
            center: true,
            className: "font-semibold bg-primary/5",
            render: (item) => item != null ? Number(item).toFixed(2) : "0.00",
        },
        {
            key: "cubosEntregue2Auxiliar",
            label: "Cub. c/ 2 Aux",
            sortable: true,
            center: true,
            className: "font-semibold bg-primary/5",
            render: (item) => item != null ? Number(item).toFixed(2) : "0.00",
        },
        {
            key: "totalCubosEntregues",
            label: "Cubagem Total",
            sortable: true,
            center: true,
            className: "font-semibold bg-primary/5",
            render: (item) => item != null ? Number(item).toFixed(2) : "0.00",
        },
        {
            key: "totalCubosRetornados",
            label: "Cubos Retornado",
            sortable: true,
            center: true,
            className: "font-semibold bg-orange-50",
            render: (item) => item != null ? Number(item).toFixed(2) : "0.00",
        },
            {
            key: "totalCubosEntreguesComRetorno",
            label: "Cubos Entregues",
            sortable: true,
            center: true,
            className: "font-semibold bg-primary/10",
            render: (item) => item != null ? Number(item).toFixed(2) : "0.00",
        },
        {
            key: "percentualRetornoTotal",
            label: "% Retorno",
            sortable: true,
            center: true,
            className: "font-semibold bg-orange-50",
            render: (item) => item != null ? `${Number(item).toFixed(2)}%` : "0.00%",
        },
        {
            key: "atingiuMetaRetorno",
            label: "Meta Retorno",
            sortable: true,
            filter: false,
            center: true,
            className: "font-semibold bg-orange-100",
            render: (item) => <span className={`px-1 py-1 font-semibold rounded-lg text-[10px] text-white ${item ? 'bg-success' : 'bg-yellow-400'}`}>
                <i className={`pr-1 fa ${item ? 'fa-check-circle' : 'fa-times-circle text-yellow-700'}`} />
                {item ? "Atingiu" : "Não Atingiu"}
            </span>

        },
        {
            key: "percentualConclusao",
            label: "% Conclusão de Rota",
            sortable: true,
            center: true,
            className:  "font-semibold bg-teal-50",
            render: (item) => item != null ? <span className={item >= 80 ? 'text-teal-700': 'text-destructive'}>{Number(item).toFixed(2)}%</span> : "—",
        },
    ], []);

    return (
        <div>
            <CustomTable
                data={data}
                columns={columns}
                showHeader={false}
                loading={loading}
                maxHeight="calc(100vh - 235px)"
                className="text-[11px]"
                exportable
                exportFilename="Acompanhamento de Volume Entregue"
                onRowSelect={(row) => onRowClick?.(row)}
                footer={(rows) => {
                    const totais = rows.reduce(
                        (acc, curr) => {
                            acc.totalEntregues += curr.totalCubosEntregues ?? 0;
                            acc.totalRetornados += curr.totalCubosRetornados ?? 0;
                            acc.total1Aux += curr.cubosEntregue1Auxiliar ?? 0;
                            acc.total2Aux += curr.cubosEntregue2Auxiliar ?? 0;
                            return acc;
                        },
                        { totalEntregues: 0, totalRetornados: 0, total1Aux: 0, total2Aux: 0 }
                    );

                    const pctRetorno = totais.totalEntregues > 0
                        ? ((totais.totalRetornados / totais.totalEntregues) * 100).toFixed(2)
                        : "0.00";

                    return (
                        <div className="flex flex-wrap justify-end gap-6 p-2 text-xs font-semibold text-foreground">
                            <span>C/ 1 Aux: {totais.total1Aux.toFixed(2)} </span>
                            <span>C/ 2 Aux: {totais.total2Aux.toFixed(2)} </span>
                            <span className="text-primary">Total Entregue: {totais.totalEntregues.toFixed(2)}</span>
                            <span className="text-orange-600">Total Retornado: {totais.totalRetornados.toFixed(2)}</span>
                            <span className="text-rose-600">% Retorno: {pctRetorno}%</span>
                        </div>
                    );
                }}
            />
        </div>
    );
}

export default TabelaVolumeEntregue;
